<template>
    <div @mouseover="calculateOffset" class="timeline-block" :class="`timeline-block__${status}`" :style="{ height: `${blockHeight}%` }">
        <div ref="infoBlock" :style="{ top: infoBlockOffset }" class="timeline-block__info" :class="`timeline-block__info--${status}`">
            <div class="timeline-block__type">{{ status }}</div>
            <div class="timeline-block__start">
                <span class="font-weight-bold">Start:</span> {{ block.startAddress.label }}
            </div>
            <div class="timeline-block__end">
                <span class="font-weight-bold">End:</span> {{ block.endAddress.label }}
            </div>
            <div class="timeline-block__duration">
                <span class="font-weight-bold">Duration:</span> {{ duration }}
            </div>
        </div>
    </div>
</template>

<script>
import TimelineBlock from '@/models/TimelineBlock'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    name: 'TimelineBlock',
    data () {
        return {
            infoBlockOffset: null
        }
    },
    props: {
        pieces: {
            required: true,
            type: Number
        },
        block: {
            required: true,
            type: TimelineBlock
        }
    },
    computed: {
        ...mapGetters({
            timelineBlockStatuses: 'dictionaryModule/getTimelineBlockStatuses'
        }),
        blockHeight () {
            let blockLength = moment(this.block.endTime).diff(moment(this.block.startTime), 'seconds')
            let percent = (blockLength * 100) / this.pieces
            return percent
        },
        status () {
            const value = this.timelineBlockStatuses.find((elem) => {
                return elem.id === this.block.status
            })

            if (!value) {
                return 'unknown'
            }

            return value.key.toLowerCase()
        },
        duration: function () {
            if (!this.block.endTime) return 'Active'

            const start = moment(this.block.startTime)
            const end = moment(this.block.endTime)
            return moment.utc(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))).format('HH:mm:ss')
        },
    },
    methods: {
        calculateOffset () {
            const bounding = this.$refs.infoBlock.getBoundingClientRect()
            const diff = bounding.bottom - window.innerHeight
            if (0 < diff) this.infoBlockOffset = `-${diff}px`
            else this.infoBlockOffset = null
        }
    }
}
</script>

<style scoped lang="scss">
.timeline-block {
    display: flex;
    width: 100%;
    position: relative;

    &__type {
        font-weight: bold;
    }

    &__offline {
        background: $danger;
    }

    &__driving {
        background: $success;
    }

    &__idle {
        background: $warning;
    }

    &__nogps {
        background: $info;
    }

    &__info {
        visibility: hidden;
        position: absolute;
        width: 350px;
        background: $secondary;
        color: $white;
        border-left: 5px solid transparent;
        padding: 5px 10px;
        left: 55px;
        top: 5px;
        z-index: 9999;

        &--offline {
            border-color: $danger;
        }

        &--driving {
            border-color: $success;
        }

        &--idle {
            border-color: $warning;
        }

        &--nogps {
            border-color: $info;
        }
    }

    &:hover {
        .timeline-block__info {
            visibility: visible;
        }
    }
}
</style>
